import PropTypes from 'prop-types';
import React from 'react';

class RetailerWeightingForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { total: 0 };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    if (this.props.retailer_weight.retailer_weights) {
      let totalValue = 0;
      this.props.retailer_weight.retailer_weights.forEach((r) => {
        const rValue = parseFloat(r.weight) || 0;
        totalValue += rValue;
      });
      this.setState({ total: totalValue });
    }
  }

  handleChange() {
    let inputs = document.querySelectorAll('.weight-percent');
    let totalValue = 0;
    inputs.forEach((input) => {
      const userValue = parseFloat(input.value) || 0;
      totalValue += userValue;
    });

    this.setState({ total: totalValue });
  }

  render() {
    return (
      <div
        id="RetailerWeightingForm"
        className="shadow overflow-hidden px-4 py-5 bg-white sm:p-6 sm:rounded-md"
      >
        <div>
          {this.props.retailer_weight.errors &&
            this.props.retailer_weight.errors.base.length > 0 && (
              <div id="error_explanation">
                <p>
                  {' '}
                  {this.props.retailer_weight.errors.base.length > 1
                    ? `${this.props.retailer_weight.errors.base.length} errors`
                    : '1 error'}{' '}
                  prohibited the weights from being saved:
                </p>
                <ul>
                  {this.props.retailer_weight.errors.base.map((error) => (
                    <li>{error}</li>
                  ))}
                </ul>
              </div>
            )}
        </div>
        <div className="grid grid-cols-2">
          <div className="col-span-1 font-medium text-gray-700">Retailer</div>
          <div className="col-span-1 col-start-2 font-medium text-gray-700">
            Weight(%)
          </div>
        </div>
        {this.props.retailers.map((retailer, index) => (
          <div className="grid grid-cols-2 py-3" id={`${retailer.name}-weight`} key={retailer.name}>
            <div className="col-span-1">
              <label className="block  text-gray-700">{retailer.name}</label>
              <input
                type="hidden"
                id="retailer_weights_retailer_weights__retailer_id"
                name="retailer_weights[retailer_weights][][retailer_id]"
                value={retailer.id}
              />
            </div>
            <div className="col-start-2">
              <input
                type="number"
                readOnly={false}
                defaultValue={
                  this.props.retailer_weight.retailer_weights
                    ? this.props.retailer_weight.retailer_weights[index].weight
                    : 0
                }
                step="0.01"
                onChange={this.handleChange}
                id={`${retailer.name}__weight`}
                name="retailer_weights[retailer_weights][][weight]"
                className="weight-percent w-7/12 px-2 mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm: border border-gray-300 rounded-md"
              ></input>
            </div>

            <input
              type="hidden"
              id="retailer_weights_retailer_weights__client_id"
              name="retailer_weights[retailer_weights][][client_id]"
              value={this.props.client}
            />
          </div>
        ))}
        <div className="col-span-1 col-start-2 grid grid-cols-2">
          <div className="col-span-1  font-medium text-gray-700">Total</div>
          <div
            id="totalCounter"
            className={
              this.state.total == 100
                ? 'text-green-600 text-sm col-span-1 col-start-2'
                : 'text-red-600 text-sm col-span-1 col-start-2'
            }
          >
            {this.state.total} %
          </div>
        </div>

        <div className="actions">
          <input type="submit" value="Submit" />
          <a class="secondary-btn ml-2" href="/weights_targets">Cancel</a>
        </div>
      </div>
    );
  }
}

RetailerWeightingForm.propTypes = {
  client: PropTypes.number,
  retailers: PropTypes.array,
};

export default RetailerWeightingForm;
